import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { localTimeButtonClicked } from 'state-management/actions'
import { Form } from 'react-bootstrap'
import Label, { useLabels } from "components/general/Label"

export function SelectorTimeZone2({ handleOpenChange }) {
    const fLabel = useLabels();
    const dispatch = useDispatch();
    const localtime = useSelector((state) => state.appGlobal.localtime)
    const sessionTimeZone = localStorage.getItem("displayTimeZone");
    const localtimeSession = sessionTimeZone === "host" ? false : true  //null value not defined by default is true (user)
    //host would mean the Paris timezone and user would mean the user's timezone
    useEffect(() => {
        dispatch(localTimeButtonClicked(localtimeSession))
    }, [])

    return (
        <Form.Select
            aria-label={fLabel({ data: 'LabelSwitchTime' })}
            onChange={() => dispatch(localTimeButtonClicked(!localtime))}
            onBlur={handleOpenChange}
            value={sessionTimeZone}//{localtime ? 'user' : 'host'}
        >
            <option key='1' value="user" >
                <Label data={'LabelLocalTime'} />
            </option>
            <option key='2' value="host">
                <Label data={'LabelVenueTime'} />
            </option>
        </Form.Select>
    );
};




const SelectorTimeZone = () => {
    const dispatch = useDispatch();
    const fLabel = useLabels();
    const [ariaLabel, setAriaLabel] = useState()
    const localtime = useSelector((state) => state.appGlobal.localtime)
    const sessionTimeZone = localStorage.getItem("displayTimeZone");
    const localtimeSession = sessionTimeZone === "host" ? false : true  //null value not defined by default is true (user)

    const handleLocalTime = (localtime) => {
        const label = localtime ? 'LabelLocalTime' : 'LabelVenueTime'
        setAriaLabel(fLabel({ data: label }))
        dispatch(localTimeButtonClicked(localtime))
    }

    useEffect(() => {
        handleLocalTime(localtimeSession)
    }, [localtimeSession])

    return (
        <div className='d-flex'>
            <span className={`switch-text-start`} ><Label data={'LabelVenueTime'} /></span>
            <span className={`switch-block`} >
                <input
                    checked={localtime}
                    className="switch-checkbox"
                    id={`switch`}
                    type="checkbox"
                    onChange={() => { }}
                />
                <button
                    className="switch-label"
                    htmlFor={`switch`}
                    onClick={() => handleLocalTime(!localtime)}
                    aria-label={ariaLabel}
                >
                    <span className={`switch-button`} ></span>
                </button>
            </span>
            <span className={`switch-text-end`} ><Label data={'LabelLocalTime'} /></span>
        </div>
    );
};


export default SelectorTimeZone;
